// src/components/FromThePitSection.jsx
import { useEffect, useState } from "react";
import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { Db } from "../firebase";
import { Link } from "react-router-dom";
import OptimizedImage from "./ΟptimizedImage";

const FromThePitSection = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const q = query(collection(Db, "event_photos"), orderBy("createdAt", "desc"), limit(3));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setEvents(data);
      } catch (error) {
        console.error("🔥 Σφάλμα κατά την ανάκτηση των events:", error);
      }
    };

    fetchEvents();
  }, []);

  if (!events.length)
    return (
      <section className="py-5" style={{ backgroundColor: "#0b0b0b" }}>
        <div className="container text-center text-light">
          <h2 className="fw-bold mb-3 text-uppercase">From The Pit</h2>
          <p>Δεν υπάρχουν ακόμη φωτογραφίες από συναυλίες.</p>
        </div>
      </section>
    );

  return (
    <section className="py-5" style={{ backgroundColor: "#0b0b0b" }}>
      <div className="container">
        <h2 className="text-light text-center fw-bold mb-4 text-uppercase">
          From The Pit
        </h2>

        <div className="row g-3">
          {events.map((event) => {
            const photos = event.images || [];
            const displayPhotos = photos.slice(0, 3);

            return (
              <div className="col-md-4" key={event.id}>
                <Link
                  to={`/events/${event.id}`}
                  className="position-relative d-block text-decoration-none"
                >
                  <div className="position-relative">
                    {displayPhotos[0] ? (
                      <OptimizedImage
                        src={displayPhotos[0]}
                        alt={event.title || "Event photo"}
                        className="img-fluid rounded shadow-lg"
                        style={{
                          width: "100%",
                          height: "250px",
                          objectFit: "cover",
                          filter: "brightness(70%)",
                          transition: "0.3s",
                        }}
                      />
                    ) : (
                      <div
                        className="bg-secondary rounded"
                        style={{
                          width: "100%",
                          height: "250px",
                        }}
                      ></div>
                    )}
                    <div
                      className="position-absolute top-50 start-50 translate-middle text-center text-light"
                      style={{
                        background: "rgba(0, 0, 0, 0.6)",
                        padding: "0.5rem 1rem",
                        borderRadius: "8px",
                      }}
                    >
                      <h5 className="fw-bold text-uppercase m-0">
                        {event.title || "Untitled Event"}
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FromThePitSection;
